import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import axios from "axios";
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';


var url = window.location.hostname;
var port = window.location.port;


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    
    this.fetchBinData = this.fetchBinData.bind(this);

    this.state = {
      loading_overlay: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',


    };
  }


 
  componentDidMount() {
    this.fetchBinData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = Util.getCookie('token');
    var location = Util.getCookie('selectedLocation');
    var username = Util.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  

 
  fetchBinData() {


    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

     const payload={
     location: this.state.selectedLocation
   }
API.post('/customer/v1/inventory_owner/view', { param: payload })

      .then(response => response.data)

      .then(data => {

        this.setState({ posts: data.data })

      })

      .then(async () => {

        this.setState({ tableRows: this.assemblePosts(), isLoading: false })

        console.log(this.state.tableRows);

      });
  }
  assemblePosts = () => {

    let posts = this.state.posts.map((post) => {

      return (

        {

          name: post.name,
          code: post.code,
          added_on: post.added_on,
          customer: post.customer,
          menu_mgmnt: post.menu_mgmnt,
          inventory: post.inventory,
          pick_pack_planning:post.pick_pack_planning,
          putaway_line_count:post.putaway_line_count,

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }



  render() {
    console.log(this.state.showInvalidItem)


    const data = {

      columns: [

        {

          label: 'Name',

          field: 'name',
          sort: 'asc',

        },

        {

          label: 'Code',

          field: 'code',
          sort: 'asc',

        },
        {
          label: "Customer",
          field: 'customer',
          sort: 'asc'
        },
        {
          label: "Inventory",
          field: 'inventory',
          sort: 'asc'
        },
        {
          label: 'Added on',
          field: 'added_on',
          sort: 'asc',
        },
        {
          label: "Menu Management",
          field: 'menu_mgmnt',
          sort: 'asc'
        },
        {
          label: 'Pick Pack planning',
          field: 'pick_pack_planning',
          sort: 'asc',
        },
        {
          label:"Putaway Line Count",
          field:"putaway_line_count",
          sort:'asc',
        }

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>

          {
            this.state.showFetchBinData && (

              <CardBody style={{ marginTop: 20 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">Inventory Owner</h4>

                  {/* <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.posts, "RetailorProductMaster")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span> */}

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  sortable={false}
                  hover
                  data={data}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'inventory_owner_view', 'datatable_pagination_change' )}
                />
              </CardBody>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));